import React, { createContext, useState, useContext } from 'react';
import { CourseIDContext } from './CourseIDContext';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { courseID } = useContext(CourseIDContext);

  const [authState, setAuthState] = useState(() => {
    const loggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
    const storedFullName = sessionStorage.getItem('fullName');
    const storedUsername = sessionStorage.getItem('username');
    const storedIsInstructor = sessionStorage.getItem('isInstructor') === 'true';
const storedIsTA = sessionStorage.getItem('isTA') === 'true';  // Add this

    return {
      isLoggedIn: loggedIn,
      fullName: storedFullName || '',
      username: storedUsername || '',
      isInstructor: storedIsInstructor,
      isTA: storedIsTA,
      redirectUrl: '/',
    };
  });

  

  const setRedirectUrl = (url) => {
    setAuthState(prevState => ({ ...prevState, redirectUrl: url }));
  };

  const handleLogin = async (username, password) => {
    try {
      // Normalize username to lowercase for consistent authentication
      const normalizedUsername = username.trim().toLowerCase();
      
      const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${apiUrl}/api/authenticate/${courseID}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: normalizedUsername, password }),
      });

      if (response.ok && !(normalizedUsername === password)) {
        const data = await response.json();
        // Store the auth token so it can be attached to subsequent API requests.
        if (data.token) {
          sessionStorage.setItem('authToken', data.token);
        }
        sessionStorage.setItem('isLoggedIn', 'true');
        sessionStorage.setItem('isInstructor', data.isInstructor.toString());
sessionStorage.setItem('isTA', data.isTA.toString());  // Add this line
        sessionStorage.setItem('username', normalizedUsername);
        sessionStorage.setItem('fullName', data.fullName);

       const newAuthState = {
  isLoggedIn: true,
  isInstructor: data.isInstructor,
  isTA: data.isTA,  // Add this
  username: normalizedUsername,
  fullName: data.fullName,
  redirectUrl: authState.redirectUrl,
};

        setAuthState(newAuthState);

        const currentRedirectUrl = newAuthState.redirectUrl;
        setRedirectUrl('/');

        return { success: true, isInstructor: data.isInstructor, redirectUrl: currentRedirectUrl };
       } else {
      // If response is not OK, we need to find out why
      if (response.status === 404) { // Assuming 404 for user not found
        return { success: false, reason: 'USER_NOT_FOUND' };
      } else if (response.status === 401) { // Assuming 401 for wrong password
        return { success: false, reason: 'WRONG_PASSWORD' };
      }  else if (normalizedUsername === password) {
        return { success: false, reason: 'RESET_PASSWORD' };
      } else {
        // Handle other HTTP errors
        return { success: false, reason: 'OTHER_ERROR' };
      }
    }
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, reason: 'NETWORK_ERROR' };
    }
  };

  const logout = () => {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('isLoggedIn');
  sessionStorage.removeItem('isInstructor');
  sessionStorage.removeItem('isTA');
  sessionStorage.removeItem('username');
  sessionStorage.removeItem('fullName');

  setAuthState({
    isLoggedIn: false,
    fullName: '',
    username: '',
    isInstructor: false,
    isTA: false,
    redirectUrl: '/',
  });
};


  const getFullNameByUsername = async (username) => {
    try {
      // Normalize username to lowercase for consistent lookup
      const normalizedUsername = username.trim().toLowerCase();
      
      const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const response = await fetch(`${apiUrl}/api/authenticate/fullname/${courseID}/${normalizedUsername}`);
      if (response.ok) {
        const data = await response.json();
        return data.fullName;
      }
      throw new Error('User not found.');
    } catch (error) {
      console.error('Error fetching full name:', error);
      return 'Unknown User';
    }
  };

  return (
    <AuthContext.Provider value={{ ...authState, handleLogin, setRedirectUrl, getFullNameByUsername, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
